export default "__VITE_ASSET__Afo4T6ZQ__";